<template>
  <div
    class="empty-forms-list"
    :style="cssVars"
    data-testid="empty-forms-list"
  >
    <h1 class="message">
      No forms exist yet
    </h1>
    <div
      v-for="(n, idx) in 7"
      :key="idx"
      class="empty-form-choice"
    />
  </div>
</template>

<script>
import cssVars from '../components/mixins/color-vars';

export default {
  name: 'EmptyFormsList',
  mixins: [cssVars]
};
</script>

<style lang="scss" scoped>
.empty-forms-list {
  display: flex;
  align-items: center;
  flex-direction: column;
  .message {
    color: #333;
    margin-bottom: 64px;
    font-size: 36px;
    line-height: 48px;
  }
  .empty-form-choice {
    box-sizing: border-box;
    margin-bottom: 32px;
    border: none;
    height: 48px;
    border-radius: 4px;
    width: 90%;
    background-color: var(--empty-forms-color);
  }
}
</style>
